import { Carriers } from "../fulfillments/fulfillment-carriers-and-services";

export enum ClaimSubmissionMethod {
  USPS = "usps",
  UPS = "ups",
  DHL = "dhl",
  AMAZON = "amazon",
  FEDEX = "fedex",
  FEDEX_SMARTPOST = "fedex_smartpost",
}

const CARRIER_TO_METHOD: Record<string, ClaimSubmissionMethod> = {
  [Carriers.USPS]: ClaimSubmissionMethod.USPS,
  [Carriers.USPS_RETURNS]: ClaimSubmissionMethod.USPS,
  [Carriers.USPS_SHIP]: ClaimSubmissionMethod.USPS,
  [Carriers.DHL_EXPRESS]: ClaimSubmissionMethod.DHL,
  [Carriers.DHL_ECS]: ClaimSubmissionMethod.DHL,
  [Carriers.AMAZON]: ClaimSubmissionMethod.AMAZON,
  [Carriers.UPS]: ClaimSubmissionMethod.UPS,
  [Carriers.UPS_SUREPOST]: ClaimSubmissionMethod.UPS,
  [Carriers.FEDEX]: ClaimSubmissionMethod.FEDEX,
  [Carriers.FEDEX_SMART_POST]: ClaimSubmissionMethod.FEDEX_SMARTPOST,
};

/** Every carrier value Redo can submit a claim for. */
export const CLAIMABLE_CARRIERS: string[] = Object.keys(CARRIER_TO_METHOD);

export function carrierToSubmissionMethod(
  carrier: string | null | undefined,
): ClaimSubmissionMethod | null {
  if (!carrier) {
    return null;
  }
  return CARRIER_TO_METHOD[carrier] ?? null;
}

export function getCarriersForMethod(method: ClaimSubmissionMethod): string[] {
  return Object.entries(CARRIER_TO_METHOD)
    .filter(([, m]) => m === method)
    .map(([carrier]) => carrier);
}
